import { render, staticRenderFns } from "./trainingBriefReport.vue?vue&type=template&id=21b91e46&scoped=true"
import script from "./trainingBriefReport.vue?vue&type=script&lang=js"
export * from "./trainingBriefReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b91e46",
  null
  
)

export default component.exports